export default {
  'log.title': 'Order push log',
  'log.title.ms': 'Manage Shopline order push Sendcloud logs',
  'log.tab.all': 'All',
  'log.tab.success': 'Synced',
  'log.tab.fail': 'Failed',
  'log.tab.push.today': 'Today‘s orders',
  'log.tab.to.Sync': 'To sync',
  'log.table.title.webHookName': 'Webhook name',
  'log.table.title.OrderNO': 'Order no',
  'log.table.title.createAt': 'Created on',
  'log.table.title.requestStatus': 'Status',
  'log.table.title.message': 'Message',
  'log.table.title.action': 'Action'
}



// WEBPACK FOOTER //
// ./src/locales/lang/en-US/dashboard/log.js